import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = [":class"]
const _hoisted_2 = ["src"]
const _hoisted_3 = { ref: "filterContainer" }
const _hoisted_4 = { ref: "sortingContainer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.$style['mobile-filter-container'])
  }, [
    _createElementVNode("div", {
      ":class": _ctx.$style['top-row']
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(_ctx.$style['first-top-row'])
      }, [
        _createElementVNode("div", {
          class: _normalizeClass(_ctx.$style['close-container'])
        }, [
          _createElementVNode("button", {
            type: "button",
            class: "close-product-filter-btn",
            onClick: _cache[0] || (_cache[0] = ($event: any) => ($options.toggleOpen())),
            "aria-label": "Close"
          })
        ], 2 /* CLASS */),
        _createElementVNode("div", {
          class: _normalizeClass(_ctx.$style['logo-container'])
        }, [
          _createElementVNode("img", {
            src: $data.logoImage,
            style: {"width":"130px"},
            loading: "lazy",
            width: "130",
            height: "23",
            alt: "Odendo"
          }, null, 8 /* PROPS */, _hoisted_2)
        ], 2 /* CLASS */),
        _createElementVNode("div", {
          class: _normalizeClass(_ctx.$style['empty-container'])
        }, null, 2 /* CLASS */)
      ], 2 /* CLASS */),
      _createElementVNode("div", {
        class: _normalizeClass(_ctx.$style['tab-selector'])
      }, [
        _createElementVNode("div", {
          class: _normalizeClass([
                        _ctx.$style['tab'],
                        $data.tab == 'filter' ? _ctx.$style['current-tab'] : '',
                    ]),
          onClick: _cache[1] || (_cache[1] = ($event: any) => ($data.tab = 'filter'))
        }, _toDisplayString($data.labels.frontendProductList.filters.tabs.filters), 3 /* TEXT, CLASS */),
        _createElementVNode("div", {
          class: _normalizeClass([
                        _ctx.$style['tab'],
                        $data.tab == 'sorting' ? _ctx.$style['current-tab'] : '',
                    ]),
          onClick: _cache[2] || (_cache[2] = ($event: any) => ($data.tab = 'sorting'))
        }, _toDisplayString($data.labels.frontendProductList.filters.tabs.sortings), 3 /* TEXT, CLASS */)
      ], 2 /* CLASS */)
    ], 8 /* PROPS */, _hoisted_1),
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.$style['tab-content'])
    }, [
      _withDirectives(_createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_3, null, 512 /* NEED_PATCH */)
      ], 512 /* NEED_PATCH */), [
        [_vShow, $data.tab == 'filter']
      ]),
      _withDirectives(_createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_4, null, 512 /* NEED_PATCH */)
      ], 512 /* NEED_PATCH */), [
        [_vShow, $data.tab == 'sorting']
      ])
    ], 2 /* CLASS */)
  ], 2 /* CLASS */))
}